export const QUESTION_TYPES = [
  'Section Header',
  'Question',
  'Finding'
];